export default {
    init() {
        let flipbooks = document.querySelectorAll('.flip-book');
        if(flipbooks) {
            Array.from(flipbooks).forEach(flipbook => {
                let layers = Array.from(flipbook.querySelectorAll('.flip-book__layer-1, .flip-book__layer-2, .flip-book__layer-3'));
                if(layers) {
                    layers.forEach(layer => {
                        layer.addEventListener('mouseenter', e => {
                            layer.style.zIndex = 999;
                            layers.forEach(layer2 => {
                                if(layer !== layer2) {
                                    layer2.style.removeProperty("z-index");
                                }
                            })
                        })
                    })


                    let flipbookImages = flipbook.querySelector('.flip-book__images')
                    if(flipbookImages) {
                        flipbookImages.addEventListener('mouseleave', e => {
                            layers.forEach(layer => {
                                layer.style.removeProperty("z-index");
                            })
                        })
                    }
                }
            })
        }
    }
}